var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{on:{"click":_vm.handleClick}},[_c(_vm.svg,{tag:"component",staticClass:"leading-none",attrs:{"width":_vm.computedSize.width,"height":_vm.computedSize.height,"stroke":"currentColor","fill":_vm.fill ? 'currentColor' : undefined}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }